module.exports = __webpack_public_path__ + "img/手机.d1bea848.png";